import React from 'react';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import RoomHero from '../components/RoomHero';
import RoomOverview from '../components/RoomOverview';
import RoomGallery from '../components/RoomGallery';
import OtherServices from '../components/OtherServices';
import img1 from '../assets/images/king_1.jpg';
import img2 from '../assets/images/king_2.jpg';
import img3 from '../assets/images/king_3.jpg';
import images6 from '../assets/images/accomedation_5.jpg';
import images7 from '../assets/images/accomedation_7.jpg';
import images2 from '../assets/images/accomedation_2.jpg';
import images3 from '../assets/images/accomedation_4.jpg';

const RoomStandard = ({ language }) => {
  const title = { en: 'Standard Room', am: 'መደበኛ ክፍል' };
  const subtitle = { en: 'Comfortable and practical stay', am: 'ምቹ እና ተግባራዊ መኖሪያ' };
  const heroImage = img1;

  const overview = {
    en: 'Our Standard Rooms are thoughtfully designed with all the essentials you need for a relaxed and practical stay, suitable for both business and leisure guests.',
    am: 'መደበኛ ክፍሎቻችን ለምቾት እና ለተግባራዊ መኖሪያ የሚያስፈልጉ አስፈላጊ መሳሪያዎች ጋር በጥንቃቄ ተዘጋጅተዋል። ለንግድ እና ለመዝናናት እንግዶች ተስማሚ ናቸው።'
  };

  const highlights = [
    { en: 'Comfortable double or queen bed', am: 'ምቹ ዳብል ወይም ኩዊን አልጋ' },
    { en: 'Smart TV and complimentary Wi‑Fi', am: 'ስማርት ቲቪ እና ነፃ ዋይ-ፋይ' },
    { en: 'Work desk and reading light', am: 'የስራ ጠረጴዛ እና የንባብ መብራት' },
    { en: 'Private bathroom with shower', am: 'በግል መታጠቢያ ቤት ከሻወር ጋር' },
    { en: 'Accommodation includes breakfast and hotel amenities', am: 'መመዝገቢያው ቁርስን እና የሆቴሉን አመናካኝ አገልግሎቶችን ያካትታል' }
  ];

  const galleryTitle = { en: 'Standard Room Gallery', am: 'የመደበኛ ክፍል ጋለሪ' };
  const images = [img1, img2, img3, images6, images7, images2, images3];

  return (
    <>
      <SEO
        title="Standard Room"
        description="Practical and comfortable Standard Rooms at Blue Nest Hotel. Perfect for business and leisure travelers."
        url="/rooms/standard"
      />
      <RoomHero title={title} subtitle={subtitle} image={heroImage} language={language} />
      <RoomOverview language={language} overview={overview} highlights={highlights} />
      <div className="container my-4 text-center">
        <Link to="/contact" className="text-decoration-none">
          <button className="room-cta-btn">
            {language === 'am' ? 'ይዘዙ ክፍል' : 'Reserve this Room'}
          </button>
        </Link>
      </div>
      <RoomGallery language={language} title={galleryTitle} images={images} />
      <OtherServices language={language} />
    </>
  );
};

export default RoomStandard;
